import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2, ClipboardCheck } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { checkupTrainerAPI } from '@/lib/api';

/* „Wer macht Check-Ups?“ (28.10.2026, backend/checkup_trainer.py): Mehrfachauswahl aus den App-Trainern.
   Leer = alle App-Trainer wie bisher. Schon übernommene Check-Ups anderer laufen normal zu Ende. Ändern nur Leitung (der Server prüft). */
export default function CheckupTrainerKarte() {
  const [daten, setDaten] = useState(null);
  const [auswahl, setAuswahl] = useState([]);
  const [arbeitet, setArbeitet] = useState(false);
  const lade = useCallback(async () => {
    try { const d = (await checkupTrainerAPI.lesen()).data; setDaten(d); setAuswahl(d.lead_ids || []); } catch { setDaten({ trainer: [], lead_ids: [] }); }
  }, []);
  useEffect(() => { lade(); }, [lade]);
  const umschalten = (id) => setAuswahl((a) => (a.includes(id) ? a.filter((x) => x !== id) : [...a, id]));
  const speichern = async () => {
    setArbeitet(true);
    try { await checkupTrainerAPI.setzen(auswahl); toast.success(auswahl.length ? 'Gespeichert' : 'Gespeichert: alle App-Trainer'); await lade(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    finally { setArbeitet(false); }
  };
  const geaendert = daten && JSON.stringify([...auswahl].sort()) !== JSON.stringify([...(daten.lead_ids || [])].sort());
  return (
    <Card className="border-border/60" data-testid="checkup-trainer-karte">
      <CardContent className="p-4 space-y-3">
        <h3 className="text-sm font-semibold flex items-center gap-2"><ClipboardCheck className="w-4 h-4 text-marke" /> Wer macht Check-Ups?</h3>
        <p className="text-xs text-muted-foreground">Nur diese Trainer bekommen neue Check-Ups angeboten und können sie übernehmen. Nichts gewählt = alle App-Trainer. Bereits übernommene Check-Ups laufen normal zu Ende.</p>
        {daten === null ? <Loader2 className="w-4 h-4 animate-spin text-muted-foreground" /> : (
          <>
            <div className="flex flex-wrap gap-2">
              {daten.trainer.map((t) => (
                <button key={t.id} type="button" onClick={() => umschalten(t.id)} data-testid={`checkup-trainer-${t.id}`}
                  className={`text-xs rounded-full border px-3 py-1 ${auswahl.includes(t.id) ? 'border-marke text-marke font-semibold' : 'text-muted-foreground'}`}>{t.name}</button>
              ))}
            </div>
            <div className="flex items-center gap-3">
              <Button size="sm" onClick={speichern} disabled={arbeitet || !geaendert} className="h-8">{arbeitet ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Speichern'}</Button>
              {daten.geaendert_von && <span className="text-[10px] text-muted-foreground">zuletzt {daten.geaendert_von}</span>}
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
